/** A base for all calculator tools */
export class ToolBase {
    // Create the tools and attempt to load the container
    constructor(containerId) {
        // If our container id is on the page, then load teh buttons and call the child class
        if (document.getElementById(containerId)) {
            if (document.getElementById('tools-calculator-submit'))
                this.addButtonHandler("tools-calculator-submit", this.onSubmit.bind(this));
            if (document.getElementById('tools-calculator-clear'))
                this.addButtonHandler("tools-calculator-clear", this.onClear.bind(this));
            if (document.getElementById('tools-error'))
                this.errorElement = document.getElementById("tools-error");
            this.onLoad();
        }
    }
    /** Subclasses can override this to load what they need */
    onLoad() {
    }
    /** Subclasses can override this to listen to the clear button */
    onClear() {
    }
    /** Subclasses can override this to listen to the save button */
    onSubmit() {
    }
    /** Subclasses can override this to listen to changes in text box values */
    onChange() {
    }
    /** Adds a button handler which calls the function when clicked */
    addButtonHandler(elementId, func) {
        let button = document.getElementById(elementId);
        button.addEventListener("click", event => {
            this.showErrorText("");
            this.hideResult();
            func();
        });
    }
    /** Returns an HTMLInputElement with an onchange which formats it as a number.
     *  This doesn't do any checks so make sure your element is valid
     */
    loadNumberBox(elementID) {
        let box = document.getElementById(elementID);
        box.onchange = () => {
            this.onChange();
            this.showErrorText("");
            let valueFormatted = box.value.match(/\d*\.?\d+/);
            box.value = (valueFormatted) ? valueFormatted[0] : "";
        };
        return box;
    }
    /** Returns an HTMLSelectElement with an onchange
     *  This doesn't do any checks so make sure your element is valid
     */
    loadSelect(elementID) {
        let box = document.getElementById(elementID);
        box.onchange = () => {
            this.onChange();
            this.showErrorText("");
        };
        return box;
    }
    /** Checks at least 1 input is empty, and shows an error if not */
    checkAtLeastOneBoxIsEmpty(...objects) {
        if (!objects.some(obj => obj.value === "")) {
            this.showErrorText("At least one box must be empty");
            return false;
        }
        return true;
    }
    /** Checks if exactly N of the inputs have a value */
    checkHasNValues(objects, numberToCheck) {
        const valuesCount = objects.filter(obj => obj.value !== "").length;
        if (valuesCount === numberToCheck)
            return true;
        const words = ["Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
        this.showErrorText(`${words[numberToCheck]} boxes must have a value`);
        return false;
    }
    /** Checks all boxes are filles */
    checkAllBoxesAreFilled(...objects) {
        for (let o of objects) {
            if (o.value === "") {
                this.showErrorText("All boxes must have a value");
                return false;
            }
        }
        return true;
    }
    /* Shows error text in the error text area */
    showErrorText(text) {
        if (this.errorElement)
            this.errorElement.innerHTML = text;
    }
    /** Show a result in a text box area */
    showResult(result) {
        var _a, _b;
        document.getElementById("calculator-result-container").style.display = "block";
        document.getElementById("calculator-result").innerHTML = result.result;
        document.getElementById("calculator-result-pre").innerHTML = (_a = result.pre) !== null && _a !== void 0 ? _a : "";
        document.getElementById("calculator-result-post").innerHTML = (_b = result.post) !== null && _b !== void 0 ? _b : "";
    }
    hideResult() {
        document.getElementById("calculator-result-container").style.display = "none";
    }
    roundNumber(n) {
        return Math.round(n * 10) / 10;
    }
}
;
export class TwoValueTool extends ToolBase {
    constructor(containerId, toolBoxIDs) {
        super(containerId);
        this.inputBoxes = [];
        if (document.getElementById(containerId)) {
            toolBoxIDs.forEach(id => {
                this.inputBoxes.push(this.loadNumberBox(id));
            });
        }
    }
    onSubmit() {
        if (this.checkHasNValues(this.inputBoxes, this.inputBoxes.length))
            this.showResult(this.onCalculate());
    }
    onClear() {
        this.inputBoxes.forEach(box => {
            box.value = "";
        });
        document.getElementById("calculator-result-container").style.display = "none";
    }
    onCalculate() {
        return { result: "This should be overridden" };
    }
}
